// extracted by mini-css-extract-plugin
export var modalFooter = "_mn-0";